<div role="main" aria-label="page">
  <div class="page-title">
    <ng-content select="ap-page-title"></ng-content>
    <ng-content select="ap-page-toolbar"></ng-content>
  </div>
  <div class="clearfix"></div>
  <ng-content select="ap-page-content"></ng-content>
</div>
